var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Typography, FormControl } from "@material-ui/core";
import { SpaciousTypography } from "../styleComponents";
import { useTypedSelector } from "../../state/store";
import LaterQuizItemAddition from "../LaterQuizItemAddition";
import MarkdownText from "../MarkdownText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import ThemeProviderContext from "../../contexes/themeProviderContext";
import AnswerComponent from "./AnswerComponent";
import AnswerLockedComponent from "./AnswerLockedComponent";
var QuestionContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: center;\n  font-size: 1.25rem;\n  margin-right: 0.8rem;\n  padding-left: 10px;\n  border-radius: 5px;\n  min-height: 2rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: center;\n  font-size: 1.25rem;\n  margin-right: 0.8rem;\n  padding-left: 10px;\n  border-radius: 5px;\n  min-height: 2rem;\n"])));
var CentralizedOnSmallScreenTypography = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media only screen and (max-width: 600px) {\n    text-align: center;\n  }\n"], ["\n  @media only screen and (max-width: 600px) {\n    text-align: center;\n  }\n"])));
var AttentionIcon = styled(FontAwesomeIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 30px !important;\n"], ["\n  font-size: 30px !important;\n"])));
var ItemContent = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: 10px;\n  > div:first-of-type {\n    display: grid;\n    grid-template-columns: 1fr 30%;\n    justify-content: space-between;\n    flex-direction: ", ";\n  }\n  ", "\n"], ["\n  margin-bottom: 10px;\n  > div:first-of-type {\n    display: grid;\n    grid-template-columns: 1fr 30%;\n    justify-content: space-between;\n    flex-direction: ", ";\n  }\n  ", "\n"])), function (_a) {
  var direction = _a.direction;
  return direction;
}, function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var LeftBorderedDiv = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  border-left: 6px solid ", ";\n  box-sizing: border-box;\n  padding: 3px;\n  padding: 0.5rem 0 0.5rem 0.5rem;\n  margin-bottom: 5px !important;\n  p:nth-of-type(1) {\n    display: none;\n  }\n  p:nth-of-type(2) {\n    margin-top: -0.25rem;\n    padding: 0 0 0 0.5rem;\n  }\n"], ["\n  display: flex;\n  border-left: 6px solid ", ";\n  box-sizing: border-box;\n  padding: 3px;\n  padding: 0.5rem 0 0.5rem 0.5rem;\n  margin-bottom: 5px !important;\n  p:nth-of-type(1) {\n    display: none;\n  }\n  p:nth-of-type(2) {\n    margin-top: -0.25rem;\n    padding: 0 0 0 0.5rem;\n  }\n"])), function (_a) {
  var correct = _a.correct;
  return correct ? "#047500" : "#DB0000";
});
var LeftAlignedMarkdownText = styled(MarkdownText)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  text-align: left;\n"], ["\n  text-align: left;\n"])));
var MultipleChoice = function MultipleChoice(_a) {
  var item = _a.item;
  var themeProvider = React.useContext(ThemeProviderContext);
  var dispatch = useDispatch();
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var answer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var items = useTypedSelector(function (state) {
    return state.quiz.items;
  });
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var languageLabels = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var displayFeedback = useTypedSelector(function (state) {
    return state.feedbackDisplayed;
  });
  if (!quiz) {
    return React.createElement("div", null);
  }
  var ItemAnswer = answer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  if (!ItemAnswer && !quizDisabled) {
    return React.createElement(LaterQuizItemAddition, {
      item: item
    });
  }
  var options = item.options;
  var direction = "row";
  var questionWidth = 5;
  var optionWidth = "auto";
  var itemAnswer = quizAnswer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  if (!itemAnswer && !quizDisabled) {
    return React.createElement("div", null, "Answer cannot be retrieved");
  }
  var optionAnswers = itemAnswer && itemAnswer.optionAnswers;
  var answerLocked = userQuizState && userQuizState.status === "locked";
  return React.createElement("div", {
    role: "group",
    "aria-label": item.title
  }, React.createElement(ItemContent, {
    direction: direction,
    providedStyles: themeProvider.multipleChoiceItemContentStyles
  }, React.createElement("div", null, React.createElement(ItemInformation, {
    item: item,
    itemAnswer: itemAnswer,
    questionWidth: questionWidth
  }), React.createElement(FormControl, {
    variant: "outlined"
  }, answerLocked ? React.createElement(AnswerLockedComponent, {
    options: options,
    quizItemId: item.id
  }) : React.createElement(AnswerComponent, {
    direction: direction,
    themeProvider: themeProvider,
    options: options,
    quizItemId: item.id,
    quizDisabled: quizDisabled
  }))), React.createElement(FeedbackPortion, {
    item: item
  })));
};
var ItemInformation = function ItemInformation(_a) {
  var item = _a.item;
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var answerLocked = userQuizState && userQuizState.status === "locked";
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  if (!languageInfo) {
    return React.createElement("div", null);
  }
  var title = item.title,
    body = item.body;
  return React.createElement(QuestionContainer, null, title && React.createElement(LeftAlignedMarkdownText, {
    Component: SpaciousTypography,
    removeParagraphs: true,
    variant: "subtitle1",
    id: "item-question-" + title
  }, title), body && React.createElement(MarkdownText, null, body));
};
var FeedbackPortion = function FeedbackPortion(_a) {
  var item = _a.item;
  var themeProvider = React.useContext(ThemeProviderContext);
  var items = useTypedSelector(function (state) {
    return state.quiz.items;
  });
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var languageLabels = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var feedbackDisplayed = useTypedSelector(function (state) {
    return state.feedbackDisplayed;
  });
  if (!feedbackDisplayed) {
    return React.createElement("div", {
      style: {
        display: "none"
      }
    });
  }
  if (!item || !languageLabels) {
    return React.createElement("div", null, "Cannot find related item or language");
  }
  var itemAnswer = quizAnswer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  if (!itemAnswer) {
    return React.createElement("div", null, "Cannot find related item answer");
  }
  var generalLabels = languageLabels.general;
  var optionAnswers = itemAnswer && itemAnswer.optionAnswers;
  var optionAnswer = optionAnswers[0];
  if (!optionAnswer) {
    return React.createElement("div", null, "No option selected.");
  }
  var selectedOption = item.options.find(function (o) {
    return o.id === optionAnswer.quizOptionId;
  });
  var feedbackMessage;
  if (item.usesSharedOptionFeedbackMessage && item.sharedOptionFeedbackMessage !== undefined) {
    feedbackMessage = item.sharedOptionFeedbackMessage;
  } else {
    var optionSuccess = selectedOption ? selectedOption.successMessage : undefined;
    var optionFailure = selectedOption ? selectedOption.failureMessage : undefined;
    var text = item;
    var successMessage = optionSuccess || text.successMessage || generalLabels.answerCorrectLabel;
    var failureMessage = optionFailure || text.failureMessage || generalLabels.answerIncorrectLabel;
    feedbackMessage = itemAnswer.correct ? successMessage : failureMessage;
  }
  var correct = itemAnswer.correct && true || false;
  var ThemedDiv = themeProvider.feedbackMessage;
  var FeedbackDiv = ThemedDiv || LeftBorderedDiv;
  if (ThemedDiv) {
    return React.createElement(ThemedDiv, {
      correct: correct,
      message: correct ? generalLabels.answerCorrectLabel : generalLabels.answerIncorrectLabel
    }, React.createElement(CentralizedOnSmallScreenTypography, {
      variant: "body1"
    }, feedbackMessage));
  }
  return React.createElement(FeedbackDiv, {
    correct: correct
  }, React.createElement(CentralizedOnSmallScreenTypography, {
    variant: "body1"
  }, React.createElement(AttentionIcon, {
    icon: faExclamationCircle
  })), React.createElement(CentralizedOnSmallScreenTypography, {
    variant: "body1"
  }, feedbackMessage));
};
export default MultipleChoice;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;